import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import RmkSvc from "@/services/Rmk";

@Module({ store, dynamic: true, namespaced: true, name: "rmk" })
class RmkModule extends VuexModule {
  data: any = null;
  loading = false;

  @Mutation SET_DATA(val: any) {
    this.data = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await RmkSvc.getByRegister(reg);
      this.SET_DATA(dt.data?.data || null);
    } catch {
      this.SET_DATA(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_DATA(null);
    this.SET_LOADING(false);
  }
}

export const storeRmk = getModule(RmkModule);
